import React, { useContext, useState } from 'react';

import { getResolvedDrumkitPortalBaseUrl } from '@utils/drumkitHostResolution';
import { getMailboxEmailAddress } from '@utils/outlookMailbox';

interface IPortalContext {
  portalUrl: string;
  setPortalUrl: (url: string) => void;
}

function defaultPortalLoginUrl(): string {
  return `${getResolvedDrumkitPortalBaseUrl(getMailboxEmailAddress(), null)}/login`;
}

const INITIAL_PORTAL_CONTEXT: IPortalContext = {
  portalUrl: '',
  setPortalUrl: () => {},
};

const PortalContext = React.createContext<IPortalContext>(
  INITIAL_PORTAL_CONTEXT
);

export const usePortalContext = () => useContext(PortalContext);

interface PortalContextProviderProps {
  children: React.ReactNode;
}

export const PortalContextProvider: React.FC<PortalContextProviderProps> = ({
  children,
}) => {
  const [portalUrl, setPortalUrl] = useState(() => defaultPortalLoginUrl());

  return (
    <PortalContext.Provider value={{ portalUrl, setPortalUrl }}>
      {children}
    </PortalContext.Provider>
  );
};
